export const checkReportsFetching = ({ reports: { fetchingData } }) => fetchingData;

export const getReportsData = ({ reports: { data } }) => data;

export const getUniqueReportYears = ({ reports: { uniqueYears } }) => uniqueYears;
